import React from 'react';
import { Button } from 'antd';
import {
  useUnwatchEmailQueue,
  useWatchEmailQueue,
} from '../../../mutation/mail';

type Props = {
  isWatching: boolean,
};

export default function WatchOrUnwatchEmailQueueButton(props: Props) {
  const { isWatching } = props;
  const {
    isLoading: watchLoading,
    mutate: watchEmailQueue,
  } = useWatchEmailQueue();
  const {
    isLoading: unwatchLoading,
    mutate: unwatchEmailQueue,
  } = useUnwatchEmailQueue();
  return (
    <Button
      icon={!isWatching ? 'eye' : 'eye-invisible'}
      loading={watchLoading || unwatchLoading}
      onClick={() => {
        if (isWatching) {
          unwatchEmailQueue();
        } else {
          watchEmailQueue();
        }
      }}
    >
      {isWatching ? 'Unwatch Email Queue' : 'Watch Email Queue'}
    </Button>
  );
}
